/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Loading_MessagesInputs */



/**
* | output |
* | --- |
* | "Loading messages…" |
*
* @param {Chat_Loading_MessagesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_loading_messages = /** @type {((inputs?: Chat_Loading_MessagesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Loading_MessagesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nachrichten werden geladen…")
	return /** @type {LocalizedString} */ ("Loading messages…")
});